import { Dialog } from "radix-ui";
import HtmlContent from "../html/HtmlContent";

export default function DialogDescription({ message }) {
  return <Dialog.Description className="my-6 text-lg font-medium text-gray-800 max-h-[80vh] overflow-y-auto overflow-x-hidden">
    <HtmlContent html={message} />
  </Dialog.Description>
}